module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    class: _vm.pageData ? '' : 'loading'
  }, [_c('page-header', {
    attrs: {
      "title": _vm.headerTitle,
      "image": _vm.headerImage,
      "content": _vm.headerContent
    }
  }), _vm._v(" "), _c('founder', {
    attrs: {
      "bio": _vm.founderBio
    }
  }), _vm._v(" "), _c('executive-advisory-board', {
    attrs: {
      "board": _vm.executiveAdvisoryBoard
    }
  }), _vm._v(" "), _c('chapter-boards', {
    attrs: {
      "boards": _vm.chapterBoards
    }
  }), _vm._v(" "), _c('mission-sponsors', {
    attrs: {
      "sponsors": _vm.missionSponsors
    }
  }), _vm._v(" "), _c('corporate-sponsors', {
    attrs: {
      "sponsors": _vm.corporateSponsors
    }
  }), _vm._v(" "), _c('testimonials', {
    attrs: {
      "testimonials": _vm.testimonials
    }
  }), _vm._v(" "), _c('thank-you', {
    attrs: {
      "thankYous": _vm.thankYous
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ac80f73e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurTeam.vue
// module id = 401
// module chunks = 2